// components/Filters.jsx
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import constants from '../config/consts.js';
import '../styles/Filters.css';

import nazad from '../icons/nazad.svg';
import nextIcon from '../icons/next.svg';

const Filters = ({ isArch, type, selectedFilters, setSelectedFilters }) => {
    const [types, setTypes] = useState([]);
    const [openMenu, setOpenMenu] = useState(null);

    const filtersRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (filtersRef.current && !filtersRef.current.contains(event.target)) {
                setOpenMenu(null);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const navigate = useNavigate();
    const goBack = () => navigate('/');

    // Определяем, какие подтипы показывать
    useEffect(() => {
        let newTypes = null;
        if (isArch) {
            // В архиве подтипы зависят от выбранной категории в фильтре
            if (selectedFilters.category === 'Doodle Toys') {
                newTypes = constants.TOYS_TYPES;
            } else if (selectedFilters.category === 'Открытки') {
                newTypes = constants.CARDS_TYPES;
            } else {
                newTypes = constants.TOYS_TYPES;
            }
        } else {
            // В обычном режиме подтипы зависят от типа страницы (toys/cards)
            if (type === 'toys') {
                newTypes = constants.TOYS_TYPES;
            } else if (type === 'cards') {
                newTypes = constants.CARDS_TYPES;
            } else {
                newTypes = constants.TOYS_TYPES;
            }
        }
        setTypes(newTypes);
    }, [isArch, type, selectedFilters.category]);

    const handleTypeSelect = (value) => {
        setSelectedFilters(prev => ({
            ...prev,
            type: value
        }));
        setOpenMenu(null);
    };

    const handleSortSelect = (sortType) => {
        setSelectedFilters(prev => ({
            ...prev,
            sort: sortType
        }));
        setOpenMenu(null);
    };

    const handleCategorySelect = (cat) => {
        setSelectedFilters(prev => ({
            ...prev,
            category: cat,
            type: 'all' // сбрасываем тип при смене категории
        }));
        setOpenMenu(null);
    };

    const toggleMenu = (menu) => {
        setOpenMenu(openMenu === menu ? null : menu);
    };

    const showTypeBlock = types !== null && types.length > 0;

    return (
        <section className="Filters" ref={filtersRef}>
            {/* Десктопная вертикальная версия */}
            <div className="filtersVertical">
                <img src={nazad} alt="Назад" className="filtersGoBack" onClick={goBack} />

                {/* {isArch && (
                    <div className="filtersCategory">
                        <p className="filtersName">Категории:</p>
                        {constants.CATEGORIES.map(cat => (
                            <p
                                key={cat}
                                className={`filterCategory ${selectedFilters.category === cat ? 'filterSelected' : ''}`}
                                onClick={() => setSelectedFilters(prev => ({ ...prev, category: cat, type: 'all' }))}
                            >
                                {cat}
                            </p>
                            
                        ))}
                        <p
                                className="filterType filterAll"
                                onClick={() => setSelectedFilters(prev => ({ ...prev, category: 'all', type: 'all' }))}
                            >
                                Все
                            </p>
                    </div>
                )} */}

                {showTypeBlock && (
                    <div className="filtersType">
                        <p className="filtersName">Виды:</p>
                        {types.map(t => (
                            <p
                                key={t}
                                className={`filterType ${selectedFilters.type === t ? 'filterSelected' : ''}`}
                                onClick={() => setSelectedFilters(prev => ({ ...prev, type: t }))}
                            >
                                {t}
                            </p>
                        ))}
                        <p
                            className="filterType filterAll"
                            onClick={() => setSelectedFilters(prev => ({ ...prev, type: 'all' }))}
                        >
                            Все
                        </p>
                    </div>
                )}

                <div className="filtersSort">
                    <p className="filtersName">Сортировать:</p>
                    {constants.SORT_TYPES.map(sort => (
                        <p
                            key={sort.sortType}
                            className={`filterSort ${selectedFilters.sort === sort.sortType ? 'filterSelected' : ''}`}
                            onClick={() => setSelectedFilters(prev => ({ ...prev, sort: sort.sortType }))}
                        >
                            {sort.name}
                        </p>
                    ))}
                </div>
            </div>

            {/* Мобильная горизонтальная версия */}
            <div className="filtersHorizontal">
                {/* {isArch && (
                    <div className="filterButton" onClick={() => toggleMenu('category')}>
                        <span>Категория</span>
                        <img
                            src={nextIcon}
                            alt="arrow"
                            className={`arrowIcon ${openMenu === 'category' ? 'open' : ''}`}
                        />
                    </div>
                )} */}

                {showTypeBlock && (
                    <div className="filterButton" onClick={() => toggleMenu('type')}>
                        <span>Вид</span>
                        <img
                            src={nextIcon}
                            alt="arrow"
                            className={`arrowIcon ${openMenu === 'type' ? 'open' : ''}`}
                        />
                    </div>
                )}

                <div className="filterButton" onClick={() => toggleMenu('sort')}>
                    <span>Сортировать</span>
                    <img
                        src={nextIcon}
                        alt="arrow"
                        className={`arrowIcon ${openMenu === 'sort' ? 'open' : ''}`}
                    />
                </div>
            </div>

            {/* Выпадающее меню категорий (для архива) */}
            {/* {isArch && (
                <div className={`dropdownMenu ${openMenu === 'category' ? 'visible' : ''}`}>
                    <div className="dropdownContent">
                        {constants.CATEGORIES.map(cat => (
                            <div
                                key={cat}
                                className={`dropdownItem ${selectedFilters.category === cat ? 'selected' : ''}`}
                                onClick={() => handleCategorySelect(cat)}
                            >
                                {cat}
                            </div>
                        ))}
                        <div
                            className="dropdownItem filterAll"
                            onClick={() => handleCategorySelect('all')}
                        >
                            Все
                        </div>
                    </div>
                </div>
            )} */}

            {/* Выпадающее меню видов */}
            {showTypeBlock && (
                <div className={`dropdownMenu ${openMenu === 'type' ? 'visible' : ''}`}>
                    <div className="dropdownContent">
                        {types.map(t => (
                            <div
                                key={t}
                                className={`dropdownItem ${selectedFilters.type === t ? 'selected' : ''}`}
                                onClick={() => handleTypeSelect(t)}
                            >
                                {t}
                            </div>
                        ))}
                        <div
                            className="dropdownItem filterAll"
                            onClick={() => handleTypeSelect('all')}
                        >
                            Все
                        </div>
                    </div>
                </div>
            )}

            {/* Выпадающее меню сортировки */}
            <div className={`dropdownMenu ${openMenu === 'sort' ? 'visible' : ''}`}>
                <div className="dropdownContent">
                    {constants.SORT_TYPES.map(sort => (
                        <div
                            key={sort.sortType}
                            className={`dropdownItem ${selectedFilters.sort === sort.sortType ? 'selected' : ''}`}
                            onClick={() => handleSortSelect(sort.sortType)}
                        >
                            {sort.name}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Filters;